var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list',{attrs:{"branches-id":_vm.branchesId,"user":_vm.user,"dates":_vm.dates,"extend-query":_vm.extendQuery}})}
var staticRenderFns = []

export { render, staticRenderFns }